/* eslint-disable @next/next/no-img-element */

import { Dialog, DialogTitle, DialogContent, Button, IconButton, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FormattedMessage } from "react-intl";
// Helpers
import { TRUSTPILOT_URL } from "@/helpers/constants";

interface TrustpilotPopupProps {
    isOpen: boolean;
    onClose: (open: boolean) => void;
    therapistName: string;
    therapistImage: string;
}

export function TrustpilotPopup({ isOpen, onClose, therapistName, therapistImage }: TrustpilotPopupProps) {
    const handleTrustpilotRedirect = () => {
        window.open(TRUSTPILOT_URL, "_blank");
        onClose(false);
    };

    const handleClose = () => {
        onClose(false);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ textAlign: "center", pr: 6 }}>
                <FormattedMessage id="trustpilot-popup-title" />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box display="flex" justifyContent="space-between" alignItems="center" py={2} mb={3}>
                    <Box
                        sx={{
                            position: "relative",
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            overflow: "hidden",
                            mb: 2
                        }}
                    >
                        <img
                            src={therapistImage}
                            alt={therapistName}
                            style={{ objectFit: "cover" }}
                            width="100%"
                            height="100%"
                        />
                    </Box>
                    <Box maxWidth="80%">
                        <Typography variant="body2" fontStyle="italic" fontSize={15} textAlign="center" mb={1}>
                            <FormattedMessage id="trustpilot-popup-description" />
                        </Typography>

                        <Typography textAlign="center" variant="body2" fontSize={15}>
                            - {therapistName}
                        </Typography>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center">
                    <Button
                        variant="contained"
                        onClick={handleTrustpilotRedirect}
                        sx={{
                            bgcolor: "#00b67a",
                            "&:hover": {
                                bgcolor: "#00a770"
                            }
                        }}
                    >
                        <FormattedMessage id="trustpilot-popup-button" />
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
